<template>
  <div class="form-element -nobottom">
    <label class="form-element__title -nomargin" v-if="title">{{
      title
    }}</label>
    <div class="form-element__multiselect">
      <form-select
        class="-auto"
        :placeholder="'Gün'"
        :list="days"
        v-model="form.day"
        :isDay="true"
      />
      <form-select
        class="-auto"
        :placeholder="'Ay'"
        :list="months"
        v-model="form.month"
        :isMonth="true"
      />
      <form-select
        class="-auto"
        :placeholder="'Yıl'"
        :list="filteredYears"
        v-model="form.year"
        :isDay="true"
      />
    </div>
    <div class="form-element__message" v-if="message">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Date,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    filterList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        day: null,
        month: null,
        year: null,
      },
      days: [
        { id: 1, name: "1", value: "01" },
        { id: 2, name: "2", value: "02" },
        { id: 3, name: "3", value: "03" },
        { id: 4, name: "4", value: "04" },
        { id: 5, name: "5", value: "05" },
        { id: 6, name: "6", value: "06" },
        { id: 7, name: "7", value: "07" },
        { id: 8, name: "8", value: "08" },
        { id: 9, name: "9", value: "09" },
        { id: 10, name: "10", value: "10" },
        { id: 11, name: "11", value: "11" },
        { id: 12, name: "12", value: "12" },
        { id: 13, name: "13", value: "13" },
        { id: 14, name: "14", value: "14" },
        { id: 15, name: "15", value: "15" },
        { id: 16, name: "16", value: "16" },
        { id: 17, name: "17", value: "17" },
        { id: 18, name: "18", value: "18" },
        { id: 19, name: "19", value: "19" },
        { id: 20, name: "20", value: "20" },
        { id: 21, name: "21", value: "21" },
        { id: 22, name: "22", value: "22" },
        { id: 23, name: "23", value: "23" },
        { id: 24, name: "24", value: "24" },
        { id: 25, name: "25", value: "25" },
        { id: 26, name: "26", value: "26" },
        { id: 27, name: "27", value: "27" },
        { id: 28, name: "28", value: "28" },
        { id: 29, name: "29", value: "29" },
        { id: 30, name: "30", value: "30" },
        { id: 31, name: "31", value: "31" },
      ],
      months: [
        {
          id: 1,
          name: "Ocak",
          value: "01",
        },
        {
          id: 2,
          name: "Şubat",
          value: "02",
        },
        {
          id: 3,
          name: "Mart",
          value: "03",
        },
        {
          id: 4,
          name: "Nisan",
          value: "04",
        },
        {
          id: 5,
          name: "Mayıs",
          value: "05",
        },
        {
          id: 6,
          name: "Haziran",
          value: "06",
        },
        {
          id: 7,
          name: "Temmuz",
          value: "07",
        },
        {
          id: 8,
          name: "Ağustos",
          value: "08",
        },
        {
          id: 9,
          name: "Eylül",
          value: "09",
        },
        {
          id: 10,
          name: "Ekim",
          value: "10",
        },
        {
          id: 11,
          name: "Kasım",
          value: "11",
        },
        {
          id: 12,
          name: "Aralık",
          value: "12",
        },
      ],
      years: [
        { id: 1, name: "1920" },
        { id: 2, name: "1921" },
        { id: 3, name: "1922" },
        { id: 4, name: "1923" },
        { id: 5, name: "1924" },
        { id: 6, name: "1925" },
        { id: 7, name: "1926" },
        { id: 8, name: "1927" },
        { id: 9, name: "1928" },
        { id: 10, name: "1929" },
        { id: 11, name: "1930" },
        { id: 12, name: "1931" },
        { id: 13, name: "1932" },
        { id: 14, name: "1933" },
        { id: 15, name: "1934" },
        { id: 16, name: "1935" },
        { id: 17, name: "1936" },
        { id: 18, name: "1937" },
        { id: 19, name: "1938" },
        { id: 20, name: "1939" },
        { id: 21, name: "1940" },
        { id: 22, name: "1941" },
        { id: 23, name: "1942" },
        { id: 24, name: "1943" },
        { id: 25, name: "1944" },
        { id: 26, name: "1945" },
        { id: 27, name: "1946" },
        { id: 28, name: "1947" },
        { id: 29, name: "1948" },
        { id: 30, name: "1949" },
        { id: 31, name: "1950" },
        { id: 32, name: "1951" },
        { id: 33, name: "1952" },
        { id: 34, name: "1953" },
        { id: 35, name: "1954" },
        { id: 36, name: "1955" },
        { id: 37, name: "1956" },
        { id: 38, name: "1957" },
        { id: 39, name: "1958" },
        { id: 40, name: "1959" },
        { id: 41, name: "1960" },
        { id: 42, name: "1961" },
        { id: 43, name: "1962" },
        { id: 44, name: "1963" },
        { id: 45, name: "1964" },
        { id: 46, name: "1965" },
        { id: 47, name: "1966" },
        { id: 48, name: "1967" },
        { id: 49, name: "1968" },
        { id: 50, name: "1969" },
        { id: 51, name: "1970" },
        { id: 52, name: "1971" },
        { id: 53, name: "1972" },
        { id: 54, name: "1973" },
        { id: 55, name: "1974" },
        { id: 56, name: "1975" },
        { id: 57, name: "1976" },
        { id: 58, name: "1977" },
        { id: 59, name: "1978" },
        { id: 60, name: "1979" },
        { id: 61, name: "1980" },
        { id: 62, name: "1981" },
        { id: 63, name: "1982" },
        { id: 64, name: "1983" },
        { id: 65, name: "1984" },
        { id: 66, name: "1985" },
        { id: 67, name: "1986" },
        { id: 68, name: "1987" },
        { id: 69, name: "1988" },
        { id: 70, name: "1989" },
        { id: 71, name: "1990" },
        { id: 72, name: "1991" },
        { id: 73, name: "1992" },
        { id: 74, name: "1993" },
        { id: 75, name: "1994" },
        { id: 76, name: "1995" },
        { id: 77, name: "1996" },
        { id: 78, name: "1997" },
        { id: 79, name: "1998" },
        { id: 80, name: "1999" },
        { id: 81, name: "2000" },
        { id: 82, name: "2001" },
        { id: 83, name: "2002" },
        { id: 84, name: "2003" },
        { id: 85, name: "2004" },
        { id: 86, name: "2005" },
        { id: 87, name: "2006" },
        { id: 88, name: "2007" },
        { id: 89, name: "2008" },
        { id: 90, name: "2009" },
        { id: 91, name: "2010" },
        { id: 92, name: "2011" },
        { id: 93, name: "2012" },
        { id: 94, name: "2013" },
        { id: 95, name: "2014" },
        { id: 96, name: "2015" },
        { id: 97, name: "2016" },
        { id: 98, name: "2017" },
        { id: 99, name: "2018" },
        { id: 100, name: "2019" },
        { id: 101, name: "2020" },
        { id: 102, name: "2021" },
        { id: 103, name: "2022" },
         { id: 104, name: "2023" },
         { id: 104, name: "2024" },
      ],
    };
  },
  watch: {
    form: {
      deep: true,
      handler: "isChange",
    },
  },
  computed: {
    filteredYears: function () {
      if (this.filterList) return this.years.filter((item) => item.id > 100);

      return this.years;
    },
  },
  methods: {
    isChange: function () {
      let vm = this;

      if (!vm.form.day || !vm.form.month || !vm.form.year)
        return vm.$emit("input", null);

      let month = vm.months.find((item) => item.name == vm.form.month).value;
      let day = vm.days.find((item) => item.name == vm.form.day).value;

      let date = `${month}-${day}-${vm.form.year}`;

      let s = new Date(date).valueOf();
      // let d = new Date(s + 0)
      let d = new Date(s + 10800000);

      return vm.$emit("input", d);
    },
  },
};
</script>